import { render, staticRenderFns } from "./frstScreen.vue?vue&type=template&id=626f5370&scoped=true"
import script from "./frstScreen.vue?vue&type=script&lang=js"
export * from "./frstScreen.vue?vue&type=script&lang=js"
import style0 from "./frstScreen.vue?vue&type=style&index=0&id=626f5370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626f5370",
  null
  
)

export default component.exports